import { render } from "./RelatorioRentabilidadeEmpresaIndex.vue?vue&type=template&id=362ef4d4&scoped=true&ts=true"
import script from "./RelatorioRentabilidadeEmpresaIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioRentabilidadeEmpresaIndex.vue?vue&type=script&lang=ts"

import "./RelatorioRentabilidadeEmpresaIndex.vue?vue&type=style&index=0&id=362ef4d4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362ef4d4"]])

export default __exports__